export default "__VITE_ASSET__B$Oun7DJ__"